import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDialpadRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 26,
			height: 26,
			x: 3,
			y: 3,
			fill: "url(#dialpadRegularPaint0)",
			rx: 4.96
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M23.5 23.8h-1.9V23q-.6.6-1.4.8a4 4 0 0 1-2 .2 4 4 0 0 1-1.8-1 5 5 0 0 1-1.1-4.9V18a5 5 0 0 1 1.4-1.9q.7-.6 1.7-.7t2 .1l.2.1.4.3.5.5.1-4.3h1.9zm-3.1-6.7q-1-.4-2 0-.6.5-1 1.1-.4.9-.4 1.9l.6 1.5q.5.5 1.1.7h1.7l1-1 .3-1.4q0-1-.3-1.8zm-6.8-9q0 1.1 1 2.5c.8.7 1 .9 1.8 1.2l.6.2v.2l-.4.3-1.4.8q-1.7 1.3-2.6 3.4v.2l-.2.2q0 .2-.2.3H12v-.2c-.3-1-1.2-3.2-3-3.6l-.5-.2v-.2l.2-.1q1-.5 1.9-1.2 1.4-1.4 2.3-3.2l.3-.7z"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "dialpadRegularPaint0",
			x1: 3,
			x2: 23.58,
			y1: 6.07,
			y2: 31.53,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#531A81" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					stopColor: "#DA2D80"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FC6B2F"
				})
			]
		}) })
	]
});
export default SvgDialpadRegularIcon;
